import httpClient from "./httpClient";

const base = "/payslip-templates";

export function listPayslipTemplateDefaults() {
  return httpClient.get(`${base}/defaults`).then((res) => res.data.data);
}
export function getCurrentPayslipTemplate() {
  return httpClient.get(`${base}/current`).then((res) => res.data.data);
}
export function savePayslipTemplate(templateDefaultId) {
  return httpClient.post(base, { templateDefaultId }).then((res) => res.data.data);
}
